import {
  AlignItems,
  Box,
  Display,
  Icon,
  IconVariant,
  Text,
  VisuallyHidden,
} from '@gousto-internal/citrus-react';
import { statefulFilterTextStyle } from './utils';
import { DietaryFilterLabelStyles } from './styles';
import { DietaryCollection } from './MenuDietaryFilters';

type DietaryFilterProps = {
  isChecked?: boolean;
  dietaryCollection: DietaryCollection;
  onChange: () => void;
};

export function DietaryFilter(props: DietaryFilterProps) {
  const { isChecked, dietaryCollection, onChange } = props;

  const color = statefulFilterTextStyle(dietaryCollection.recipeCount, isChecked);

  return (
    <DietaryFilterLabelStyles
      key={dietaryCollection.slug}
      hasRecipes={dietaryCollection.recipeCount > 0}
      isChecked={isChecked}
    >
      <Box display={Display.Flex} alignItems={AlignItems.Center} gap={1}>
        <Text size={0} color={color}>
          {dietaryCollection.name}
        </Text>
        <Text size={0} color={color} style={{ minWidth: '1.2rem', textAlign: 'center' }}>
          ({dietaryCollection.recipeCount})
        </Text>
      </Box>

      <Box display={Display.Flex} color={color}>
        <Icon
          size={4}
          variant={IconVariant.Inherit}
          name={isChecked ? 'success' : 'radio_default'}
        />
      </Box>

      <VisuallyHidden>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          value={dietaryCollection.slug}
        />
      </VisuallyHidden>
    </DietaryFilterLabelStyles>
  );
}
